<template>
  <RouterLink
    :to="{
      name: 'work_form_view_document_route',
      params: { document_id: document.id }
    }"
    class="group relative block w-full rounded-lg border border-gray-100 bg-white p-1.5 shadow-sm hover:shadow-md dark:border-slate-600 dark:bg-slate-800"
  >
    <div class="flex items-start gap-3 rounded-sm p-1.5">
      <div
        class="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-white"
      >
        <FontAwesomeIcon :icon="['fal', 'file-pdf']" size="2x" fixed-width />
      </div>
      <div class="min-w-0 flex-1">
        <p
          class="text-lg leading-tight font-medium text-gray-900 capitalize-first dark:text-gray-100"
        >
          {{ document.name }}
        </p>
        <p v-if="document.description" class="truncate text-sm text-gray-500">
          {{ document.description }}
        </p>
      </div>
      <FontAwesomeIcon
        v-if="document.with_form"
        :icon="['fal', 'pen-field']"
        class="mt-1 shrink-0 text-gray-400 group-hover:text-primary-500"
        fixed-width
      />
    </div>
  </RouterLink>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * A document of a work's documents tab, as FM's DossierDocumentCardComponent.
 * It opens the document's preview, where its form (if any) is filled.
 */
export default {
  name: 'WorkDocumentCard',
  components: { FontAwesomeIcon },
  props: {
    document: { type: Object, required: true }
  }
}
</script>
